import { USER_KEY } from '../constants'

export default () => {
  const { hasOrderSheet } = JSON.parse(localStorage.getItem(USER_KEY) || '{}')
  return hasOrderSheet
}
